export function isoDate() {
  let dataAtual = new Date();
  let ano = dataAtual.getFullYear();
  let mes = ("0" + (dataAtual.getMonth() + 1)).slice(-2); 
  let dia = ("0" + dataAtual.getDate()).slice(-2);
  let hora = ("0" + dataAtual.getHours()).slice(-2);
  let minuto = ("0" + dataAtual.getMinutes()).slice(-2);
  let segundo = ("0" + dataAtual.getSeconds()).slice(-2);
  let milissegundo = ("00" + dataAtual.getMilliseconds()).slice(-3);
  return `${ano}-${mes}-${dia}T${hora}:${minuto}:${segundo}.${milissegundo}`;
}
